export const firstLetter = (word: string) =>
  word ? word.substring(0, 1) : null;
